<div style="display: none;">
    <div #script></div>
</div>
<a href="#" (click)="login($event)">
    <ng-content></ng-content>
</a>